export default "__VITE_ASSET__BLW44EcL__"